export default {
  "content": "<path d=\"M1 8h13m0 0L7 1m7 7l-7 7\" stroke=\"#ff00cb\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>",
  "attrs": {
    "width": "16",
    "height": "16",
    "viewBox": "0 0 16 16",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};